import Button from "@/common/components/Button";
import { TmaisBadge, TmaisBadgeTableItem } from "../types/tmaisBadge.type";
import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";

const formatUsage = (value: number) => {
  const formatter = new Intl.NumberFormat("pt-BR");
  return `${formatter.format(value)} itens`;
};

const renderStatus = (discardedAt: string | null) => {
  const isActive = !discardedAt;
  return <span>{isActive ? "Ativo" : "Inativo"}</span>;
};

const renderIcon = (badge: TmaisBadge) => {
  if (badge.icon?.url) {
    return (
      <img
        src={badge.icon.url}
        alt={`Ícone do destaque ${badge.display_name}`}
        className="size-12 rounded-md object-contain bg-white"
      />
    );
  }

  return <span className="text-xs italic text-white-400">Sem ícone</span>;
};

const renderColor = (color?: string | null) => {
  return (
    <div className="flex items-center gap-2">
      <span
        className="size-4 rounded-full border border-white-200"
        style={{ backgroundColor: color || "#D0D5DD" }}
      />
      <span className="text-sm font-semibold uppercase">{color || "--"}</span>
    </div>
  );
};

export class TmaisBadgesTransformer {
  static tableTransformer() {
    return (badges: TmaisBadge[] = []): TmaisBadgeTableItem[] =>
      badges.map((badge) => ({
        id: badge.id,
        status: renderStatus(badge.discarded_at),
        icon: renderIcon(badge),
        display_name: badge.display_name,
        background_color_cell: renderColor(badge.background_color),
        text_color_cell: renderColor(badge.text_color),
        usage: formatUsage(badge.products_count),
        actions: (
          <Link to={`/tmais-badges/${badge.id}`} className="cursor-pointer">
            <Button
              name="access_tmais_badges_show"
              className="bg-transparent hover:bg-transparent p-0 text-[#ffffffde] hover:text-[#ffffffde]"
              operationKlassToCheckPermission="Admin::Tmais::Badges::Show"
            >
              <ArrowBigRight width={24} height={24} strokeWidth={2} />
            </Button>
          </Link>
        ),
      }));
  }
}
